<template>
  <nav class="mb-6 z-10 w-fit">
    <h3 class="text-2xl m-0">{{ $t("introduction") }}</h3>
    <ul class="flex flex-col items-start space-y-1 text-md" id="main-nav">
      <li class="whitespace-nowrap w-fit">
        <router-link
          :to="{ name: 'BpHome', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          active-class=""
          exact-active-class="active-nav-link"
          class="mra-languages"
        >
          {{ $t("nav.home") }}
        </router-link>
      </li>
      <li class="whitespace-nowrap w-fit" id="introduction">
        <router-link
          :to="{ name: 'BpForeword', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.foreword") }}
        </router-link>
      </li>
      <li class="whitespace-nowrap w-fit">
        <router-link
          :to="{ name: 'BpMission', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.mission") }}
        </router-link>
      </li>
      <li class="whitespace-nowrap w-fit">
        <router-link
          :to="{ name: 'BpVision', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.vision2032") }}
        </router-link>
      </li>
      <li class="whitespace-nowrap w-fit">
        <router-link
          :to="{ name: 'BpOverview', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.overview") }}
        </router-link>
      </li>
    </ul>
  </nav>
  <nav class="flex flex-col justify-between z-10 mb-6" id="bp-themes">
    <h3 class="text-2xl">{{ $t("bpThemes") }}</h3>
    <ul
      class="flex flex-col lg:items-start space-y-3 md:space-y-2 md:text-md md:max-w-[70vw] space-y-2"
      id="bp-theme-nav"
    >
      <li class="bp-link bp-link-dfc">
        <router-link
          :to="{ name: 'BpDfc', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.dfc") }}
        </router-link>
      </li>
      <li class="bp-link bp-link-es">
        <router-link
          :to="{ name: 'BpEs', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.es") }}
        </router-link>
      </li>
      <li class="bp-link bp-link-wwo">
        <router-link
          :to="{ name: 'BpWwo', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.wwo") }}
        </router-link>
      </li>
      <li class="bp-link bp-link-gptw">
        <router-link
          :to="{ name: 'BpGptw', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.gptw") }}
        </router-link>
      </li>
      <li class="bp-link bp-link-fftf">
        <router-link
          :to="{ name: 'BpFftf', params: { locale: resolvedLocale } }"
          @click="$emit('close')"
          class="mra-languages"
        >
          {{ $t("nav.fftf") }}
        </router-link>
      </li>
    </ul>
  </nav>
  <nav class="z-10 w-fit mb-6" id="edi-plan">
    <h3 class="text-2xl">Equality, diversity and inclusion</h3>
    <ul
      class="flex flex-col lg:items-start space-y-3 md:space-y-2 md:text-md md:max-w-[70vw] space-y-2"
    >
      <li>
        <router-link to="/edi-plan/edi-foreword" @click="$emit('close')">
          Everyday inclusion foreword
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/inclusion-policies" @click="$emit('close')">
          Our everyday inclusion priorities
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/our-people" @click="$emit('close')">
          Our people
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/our-workplace" @click="$emit('close')">
          Our workplace
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/our-services" @click="$emit('close')">
          Our services
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/our-partnerships" @click="$emit('close')">
          Our partnerships
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/antiracism-policies" @click="$emit('close')">
          Our anti-racism policies
        </router-link>
      </li>
      <li>
        <router-link to="/edi-plan/inclusion-strategy" @click="$emit('close')">
          Our achievements 2022 to 2024
        </router-link>
      </li>
    </ul>
  </nav>
  <nav class="z-10 w-fit mb-6">
    <h3 class="text-2xl">Health, safety and wellbeing</h3>
    <ul
      class="flex flex-col lg:items-start space-y-3 md:space-y-2 md:text-md md:max-w-[70vw] space-y-2"
    >
      <li>
        <router-link to="/hsw-plan/hsw-foreword" @click="$emit('close')">
          Health, safety and wellbeing foreword
        </router-link>
      </li>
      <li>
        <router-link to="/hsw-plan/hsw-priorities" @click="$emit('close')">
          Our HSW priorities
        </router-link>
      </li>
      <li>
        <router-link to="/hsw-plan/safety-culture" @click="$emit('close')">
          Developing our safety-focused culture
        </router-link>
      </li>
      <li>
        <router-link
          to="/hsw-plan/technology-and-innovation"
          @click="$emit('close')"
        >
          Technology and innovation
        </router-link>
      </li>
      <li>
        <router-link to="/hsw-plan/safe-delivery" @click="$emit('close')">
          Safe delivery through others
        </router-link>
      </li>
      <li>
        <router-link to="/hsw-plan/are-we-succeeding" @click="$emit('close')">
          How will we know we are succeeding?
        </router-link>
      </li>
      <li>
        <router-link to="/hsw-plan/hsw-achievements" @click="$emit('close')">
          Our 2022-2025 achievements
        </router-link>
      </li>
    </ul>
  </nav>
  <nav class="z-10 w-fit mb-6" id="sustainability-plan">
    <h3 class="text-2xl">Sustainability</h3>
    <ul
      class="flex flex-col lg:items-start space-y-3 md:space-y-2 md:text-md md:max-w-[70vw] space-y-2"
    >
      <li>
        <router-link to="/sus-plan/sus-foreword" @click="$emit('close')">
          Sustainability plan foreword
        </router-link>
      </li>
      <li>
        <router-link to="/sus-plan/sus-priorities" @click="$emit('close')">
          Our sustainability priorities
        </router-link>
      </li>
      <li>
        <router-link to="/sus-plan/greenhouse-gases" @click="$emit('close')">
          Reducing our greenhouse gas emissions
        </router-link>
      </li>
      <li>
        <router-link to="/sus-plan/nature-positive" @click="$emit('close')">
          Being nature positive
        </router-link>
      </li>
      <li>
        <router-link to="/sus-plan/circular-economy" @click="$emit('close')">
          Towards a circular economy
        </router-link>
      </li>
      <li>
        <router-link
          to="/sus-plan/climate-change-adaptation"
          @click="$emit('close')"
        >
          Climate change adaptation
        </router-link>
      </li>
      <li>
        <router-link
          to="/sus-plan/enabling-social-value"
          @click="$emit('close')"
        >
          Enabling social value
        </router-link>
      </li>
      <li>
        <router-link to="/sus-plan/sustainable-change" @click="$emit('close')">
          Empowering sustainable change
        </router-link>
      </li>
    </ul>
  </nav>
  <nav class="z-10 w-fit mb-6" id="ccaap-plan">
    <h3 class="text-2xl">Climate Adaptation</h3>
    <ul
      class="flex flex-col lg:items-start space-y-3 md:space-y-2 md:text-md md:max-w-[70vw] space-y-2"
    >
      <li>
        <router-link to="/ccaap/ccaap-foreword" @click="$emit('close')">
          Climate adaptation foreword
        </router-link>
      </li>
      <li>
        <router-link to="/ccaap/ccaap-priorities" @click="$emit('close')">
          Our climate adaptation priorities
        </router-link>
      </li>
      <li>
        <router-link
          to="/ccaap/ccaap-maintaining-infrastructure"
          @click="$emit('close')"
        >
          Maintaining infrastructure and operations
        </router-link>
      </li>
      <li>
        <router-link to="/ccaap/climate-intelligence" @click="$emit('close')">
          Harnessing climate intelligence
        </router-link>
      </li>
      <li>
        <router-link to="/ccaap/ccaap-resilient-future" @click="$emit('close')">
          Managing our climate risks
        </router-link>
      </li>
      <li>
        <router-link
          to="/ccaap/ccaap-strengthen-partnerships"
          @click="$emit('close')"
        >
          Strengthening our partnerships
        </router-link>
      </li>
      <li>
        <router-link
          to="/ccaap/ccaap-skills-and-capabilities"
          @click="$emit('close')"
        >
          Developing our skills and capabilities
        </router-link>
      </li>
      <li>
        <router-link to="/ccaap/ccaap-succeeding" @click="$emit('close')">
          How will we know we are succeeding?
        </router-link>
      </li>
      <li>
        <router-link to="/ccaap/ccaap-achievements" @click="$emit('close')">
          Our 2023-2026 achievements
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "NavigationLinks",
  emits: ["close"],
  props: {
    locale: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedLocale() {
      // prefer prop, fallback to route or i18n
      return (
        this.locale || this.$route?.params?.locale || this.$i18n?.locale || "en"
      );
    },
    introLinks() {
      return [
        { name: "BpHome", label: "nav.home" },
        { name: "BpForeword", label: "nav.foreword" },
        { name: "BpMission", label: "nav.mission" },
        { name: "BpVision", label: "nav.vision2032" },
        { name: "BpOverview", label: "nav.overview" },
      ];
    },
  },
};
</script>
